export default __webpack_public_path__ + "static/design-hero-background-eba0a38c63ef283a4b13687d2050a2c9.png";